export enum BankAccountType {
    CHECKING = "CHECKING",
    SAVING = "SAVING"
}